{
  "sectionHeader": "Statistik der aufgegebenen Zeit",
  "sectionPara": "Sie können auch die Schwellenwerte für die Dauer der abgebrochenen Nachrichten, die von den sieben Varianten der eingehenden abgebrochenen Statistik im Stil „Abgebrochen < = Xs“ verwendet werden, spezifisch anpassen.",
  "target1Label": "Ziel 1:",
  "target1Placeholder": "60",
  "target2Label": "Ziel 2:",
  "target2Placeholder": "90",
  "target3Label": "Ziel 3:",
  "target3Placeholder": "120",
  "target4Label": "Ziel 4:",
  "target4Placeholder": "150",
  "target5Label": "Ziel 5:",
  "target5Placeholder": "180",
  "target6Label": "Ziel 6:",
  "target6Placeholder": "300",
  "targetUnits": "s",
  "resetAnswerTargetsButtonLabel": "Verlassene Intervalle zurücksetzen",
  "resetAnswerTargetsPrompt": "Sind Sie sicher, dass Sie alle 6 aufgegebenen Schwellenwerteinstellungen für eingehenden Datenverkehr auf ihre Standardwerte zurücksetzen möchten?",
  "resetAnswerTargetsConfirm": "Bestätigen",
  "resetAnswerTargetsCancel": "Absagen",
  "NAME": "AbandonedTimeStatisticLanguage"
}